module.exports = __webpack_public_path__ + "static/img/1162_phase_function_Paper_PointsHejduk_Prediction.aff41b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1162_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gwlt
// module chunks = 0